import { MilestoneRequestApi } from '../api-typings/projects/projects';
import { transformCurrency } from '../currency/currency.transformers';
import { MilestoneRequest } from './milestone-request.model';

export function transformMilestoneRequest(
  milestoneRequest: MilestoneRequestApi,
): MilestoneRequest {
  return {
    // TODO fix the id thing - probably just change the api type;
    id: milestoneRequest.id || Math.random(),
    bidderId: milestoneRequest.bidder_id,
    bidId: milestoneRequest.bid_id,
    timeRequested: milestoneRequest.time_requested,
    amount: milestoneRequest.amount,
    projectOwnerId: milestoneRequest.project_owner_id,
    projectId: milestoneRequest.project_id,
    description: milestoneRequest.description,
    currency: milestoneRequest.currency
      ? transformCurrency(milestoneRequest.currency)
      : undefined,
    status: milestoneRequest.status,
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/it/webapp/src/app/@shared/datastore/milestone-request/milestone-request.transformers.ts